module.exports = __webpack_public_path__ + "img/Coin@2x.446bfed5.png";